import React, { useState } from "react";
import "./Awards.css";

const awardsImages = [
  {
    src: "/images/awards/achive1.jpg",
    alt: "Award ceremony",
    title: "आर. आर. पाटील सुंदर गाव पुरस्कार - 1",
  },
  {
    src: "/images/awards/achive2.jpg",
    alt: "Award trophy",
    title: "आर. आर. पाटील सुंदर गाव पुरस्कार - 2",
  },
  // Add more awards here
];

const Awards = () => {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  return (
    <div className="awards-page">
      <header className="awards-header">
        <h1>Awards & Recognitions</h1>
        <p className="awards-subtitle">
          Celebrating the achievements and recognitions of Nimgoan Ketki Gram Panchayat
        </p>
      </header>

      <section className="awards-section">
        <div className="awards-grid">
          {awardsImages.map((award, index) => (
            <div className="award-card" key={index}>
              <img
                src={award.src}
                alt={award.alt}
                className="award-thumb"
                onClick={() => setLightboxIndex(index)}
              />
              <div className="award-title">{award.title}</div>
            </div>
          ))}
        </div>
      </section>

      {lightboxIndex !== null && (
        <div className="lightbox" onClick={() => setLightboxIndex(null)}>
          <span className="close">&times;</span>
          <img
            className="lightbox-content"
            src={awardsImages[lightboxIndex].src}
            alt={awardsImages[lightboxIndex].title}
          />
          <p className="lightbox-title">{awardsImages[lightboxIndex].title}</p>
        </div>
      )}
    </div>
  );
};

export default Awards;
